import React from "react";
import { Button } from "./Button";
import { Modal } from "./Modal";

interface Props {
  open: boolean;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  setOpen: (open: boolean) => void;
  onDelete: () => void;
  onCancel: () => void;
}

export const ModalDeleteConfirm = ({
  open,
  title = "アカウントを削除しますか？",
  subtitle = (
    <>
      この操作は永久的で、元に戻すことはできません <br />
      関連するすべてのデータはシステムから完全に削除されます。
      <br />
      本当に続行してもよろしいですか？
    </>
  ),
  setOpen,
  onDelete,
  onCancel,
}: Props) => {
  return (
    <Modal open={open} onOpenChange={setOpen} className="2xl:w-[35vw]">
      <p className="text-lg font-bold leading-7">{title}</p>
      <p className="text-sm leading-[1.375rem] p-4 mt-4 -mx-4 border-b border-grey-300">
        {subtitle}
      </p>
      <div className="flex justify-end gap-2 mt-4">
        <Button buttonType="text" onClick={onCancel} className="!h-12">
          キャンセル
        </Button>
        <Button
          variant="solid"
          color="danger"
          onClick={onDelete}
          className="!h-12"
        >
          削除
        </Button>
      </div>
    </Modal>
  );
};
